import React, { useEffect } from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import "./App.css";
import TopBar from "./components/TopBar";
import AboutUs from "./components/AboutUs";
import Services from "./components/Services";
import Process from "./components/Process";
import LogoMarquee from "./components/LogoMarquee";
import Testimonials from "./components/Testimonials";
import ContactUs from "./components/ContactUs";

function App() {
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const homeSection = document.getElementById("home");
    if (homeSection) {
      homeSection.scrollIntoView({ behavior: "auto", block: "start" });
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <>
      <TopBar />
      <Navbar />
      <HeroSection />
      <LogoMarquee />
      <AboutUs />
      <Services />
      <Process />
      <Testimonials />
      <ContactUs />
    </>
  );
}

export default App;
